<template>
  <svg width="26" height="18" viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 13.7647V16.9412C0 17.526 0.485013 18 1.08332 18H24.9167C25.515 18 26 17.526 26 16.9412V13.7647H0Z"
      fill="#BEDBEB"
    />
    <path
      d="M8.66451 2.96465C4.49633 4.57884 1.60789 8.34297 1.1895 12.7059H8.66451V2.96465Z"
      fill="#BEDBEB"
    />
    <path
      d="M17.3346 2.96465V12.7059H24.8096C24.3912 8.34297 21.5028 4.57884 17.3346 2.96465Z"
      fill="#BEDBEB"
    />
    <path
      d="M16.25 1.05881C16.25 0.47404 15.765 0 15.1667 0H10.8334C10.235 0 9.75002 0.47404 9.75002 1.05881V12.7059H16.25V1.05881Z"
      fill="#BEDBEB"
    />
  </svg>
</template>

<script>
export default {
  name: 'Employee',
}
</script>

<style scoped></style>
